export const LeaseMappingRequest = {
  tenantId: 'lease_id',
  leaseStartDate: 'arrangement.arrangement_start_date',
  leaseStartDateEstF: 'arrangement.arrangement_start_date_estimated_f',
  leaseEndDate: 'arrangement.arrangement_end_date',
  leaseEndDateEstF: 'arrangement.arrangement_end_date_estimated_f',
  rentRate: 'arrangement.base_rent_monthly',
  rentRateUOM: 'arrangement.ref_base_rent_monthly_uom_desc',
  rentRateEstF: 'arrangement.base_rent_monthly_estimated_f',
  spaceSizeEstF: 'arrangement.total_leased_space_estimated_f',
  industryNaicsId: 'arrangement.ref_naics_classification_desc',
  ownerOccupied: 'arrangement.owner_occupied_f',
  notes: 'arrangement.lease_arrangement_notes',
};

export const TenantMappingRequest = {
  tenantId: 'tenant_id',
  suiteNumber: 'property_space.suite_number',
  spaceId: 'property_space.id',
  spaceSize: 'property_space.leased_space_size',
  spaceSizeUOM: 'property_space.leased_space_size_uom_desc',
  leaseStartDate: 'property_space.lease_start_date',
  leaseEndDate: 'property_space.lease_expiration_date',
  rentRate: 'property_space.estimated_rent_amount',
  rentRateUOM: 'property_space.estimated_rent_amount_uom',
  industryNaicsId: 'tenant.ref_naics_classification_desc',
  notes: 'tenant.tenancy_notes',
  requestId: 'request.source_id',
};

export const AvailabilityPropertyMappingRequest = {
  availabilityId: 'availability_id',
  floorNo: 'propAssociation.floor_suite.floor_number',
  suiteNumber: 'propAssociation.floor_suite.suite_number',
  propertyId: 'propAssociation.property_id',
  propertyUsageId: 'propAssociation.property_usage_id',
  requestId: 'request.source_id',
};

export const AvailabilityMappingRequest = {
  availabilityId: 'availability_id',
  requestId: 'request.source_id',
  spaceSize: 'availability.available_space',
  spaceSizeUOM: 'availability.available_space_uom_desc',
  onMarketDate: 'availability.date_on_market',
  availabilityType: 'availability.ref_availability_type_desc',
  rentRate: 'availability.asking_rental_rate_yearly',
  rentRateUOM: 'availability.asking_rental_rate_yearly_uom_desc',
  availabilityStatus: 'availability.ref_space_availability_status_desc',
  dateAvailable: 'availability.date_available',
  vacant: 'availability.vacant_f',
  notes: 'availability.listing_notes',
  leaseType: 'availability.ref_lease_type_desc',
  possession: 'availability.ref_possession_type_desc',
  estimated: 'availability.estimated_asking_rent_f',
  minAskingRateMo: 'availability.minimum_asking_rate_monthly',
  minAskingRateMoUom: 'availability.minimum_asking_rate_monthly_uom',
  maxAskingRateMo: 'availability.maximum_asking_rate_monthly',
  maxAskingRateMoUom: 'availability.maximum_asking_rate_monthly_uom',
  minAskingRateYr: 'availability.minimum_asking_rate_yearly',
  minAskingRateYrUom: 'availability.minimum_asking_rate_yearly_uom',
  maxAskingRateYr: 'availability.maximum_asking_rate_yearly',
  maxAskingRateYrUom: 'availability.maximum_asking_rate_yearly_uom',
  minDivisibleSpace: 'availability.minimum_divisible_surface_area',
  minDivisibleSpaceUOM: 'availability.minimum_divisible_surface_area_uom_desc',
  contiguousArea: 'availability.total_contiguous_area_of_space',
  contiguousAreaUOM: 'availability.total_contiguous_area_of_space_uom_desc',
};
